@if (basdata && searchFilter) {
  <rask-arbetsorder-search-filter [title]="texts.filters.matning" (toggleVisibility)="toggleShow()" [visible]="isVisible" [hasValues]="isDirty()" aid="filterMatning">
    <div class="planeringsstatus-panel">
      <div class="planeringsstatus-panel-items">
        <div class="row">
          <rask-input [label]="texts.matning.mottagare" [(ngModel)]="searchFilter.virkesorder.mottagare" class="col-3" aid="filterVirkesorderMottagare" (change)="onChangeString($event, 'mottagare')"></rask-input>
          <rask-input [label]="texts.matning.redovisningshanvisning" [(ngModel)]="searchFilter.virkesorder.redovisningshanvisning" class="col-3" aid="filterredovisningshanvisning" (change)="onChangeString($event, 'redovisningshanvisning')"></rask-input>
        </div>
        <div class="row">
          <rask-multi-selector
            class="col-3"
            [label]="texts.matning.avtalatMattslag"
            [items]="mattslag"
            bindLabel="namn"
            bindValue="namn"
            [selected]="searchFilter.virkesorder.avtalatMattslag"
            aid="filterVirkesorderAvtalatMattslag"
            (change)="onChangeMattslag($event)">
          </rask-multi-selector>
          <rask-selector class="col-3" label="Ersättningsgrundande mätning" [values]="ersattningTyper" [(ngModel)]="skordarmatning"></rask-selector>
        </div>
      </div>
    </div>
  </rask-arbetsorder-search-filter>
}
